import { createReducer } from 'typesafe-actions';

import { updateFetchKey } from '../actions';

const initialState = {
  Appointment: 0,
  AppointmentType: 0,
  Availability: 0,
  Broadcast: 0,
  ChatActivity: 0,
  Diagnosis: 0,
  Facility: 0,
  FileUpload: 0,
  Followup: 0,
  Group: 0,
  GroupInvite: 0,
  Insurance: 0,
  Message: 0,
  MessageTemplate: 0,
  Offer: 0,
  Organization: 0,
  Patient: 0,
  PatientForm: 0,
  PatientFormTemplate: 0,
  PatientMessageTemplate: 0,
  Provider: 0,
  Recalls: 0,
  Referral: 0,
  Reminder: 0,
  Setting: 0,
  Telehealth: 0,
  Upload: 0,
  User: 0,
  WaitingRoom: 0,
  WaitingRoomPatient: 0,
  Waitlist: 0,
};

export type FetchKeysStoreKey = keyof typeof initialState;

const createFetchKeysReducer = () =>
  createReducer(initialState).handleAction(updateFetchKey, (state, action) => ({
    ...state,
    [action.payload]: state[action.payload] + 1,
  }));

export default createFetchKeysReducer;
